<template>
<div>
  <vue-clock-picker
    :name="name"
    :id="name"
    :required="required"
    input-class="form-control form-control-sm clock-pick"
    v-model="post"
    @timeset="send"
    :readonly="false"
  ></vue-clock-picker>
</div>
</template>

<script>
import VueClockPicker from "@pencilpix/vue2-clock-picker";
import "@pencilpix/vue2-clock-picker/dist/vue2-clock-picker.min.css";

export default {
  props: ["name", "validation", "content"],
  data() {
    return {
      post: this.content,
    };
  },
  mounted() {
    if (this.content != "" && this.content != null) {
      this.post = this.content.slice(0, 5);
      this.send();
    }
  },
  components: {
    VueClockPicker,
  },
  computed: {
    required() {
      if (this.validation == "required") {
        return true;
      }

      return false;
    },
  },
  methods: {
    send() {
      this.$emit("post", {
        name: this.name,
        value: this.post,
      });
    },
  },
};
</script>